import { render } from "./complaint_card.vue?vue&type=template&id=2d762fc2"
import script from "./complaint_card.vue?vue&type=script&lang=js"
export * from "./complaint_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__